<h6 class="title_2" *ngIf="!isBtnDisplay">{{ 'PROCESSES.ACCOMMODATION.LIST.PAYMENT_SUMMARY.TITLE' | translate }}</h6>
<button (click)="btnDisplayClicked()" *ngIf="isBtnDisplay" class="btn border subtitle_1" type="button">
  {{ 'PROCESSES.ACCOMMODATION.LIST.PAYMENT_SUMMARY.TITLE_2' | translate }}
</button>

<div *ngIf="!isBtnDisplay" class="pb-2">
  <div class="flex-column border-bottom border-1 pb-2 mb-2 col-fees">
    <span class="subtitle_1">{{ 'PROCESSES.ACCOMMODATION.LIST.PAYMENT_SUMMARY.BOOKING_PROCESS' | translate }}</span>
    <span class="text_1"> {{ 'PROCESSES.ACCOMMODATION.LIST.PAYMENT_SUMMARY.BOOKING_PROCESS_TO' | translate }}</span>
    <div class="d-flex justify-content-between mt-2 line-fees">
      <small class="text-underline subtitle_2 mediumGray"
        ngbTooltip="{{ 'PROCESSES.ACCOMMODATION.P_SPEC.LIST.GUARANTOR' | translate }}"
        placement="top-start">{{ 'PROCESSES.ACCOMMODATION.LIST.PAYMENT_SUMMARY.BOOKING_FEES' | translate }}</small>
      <small class="title_3">
        <span class="text-decoration-line-through me-2 mediumGray subtitle_2" *ngIf="selectedRoom.property_price && selectedRoom.property_price.old_reservation_fees && (selectedRoom.property_price['old_reservation_fees'] > selectedRoom.property_price['reservation_fees'])">
          {{ selectedRoom.property_price['old_reservation_fees'] | number: '1.0-0'}}€
        </span>
        <span [ngClass]="{'text-grad-red':selectedRoom.property_price['old_reservation_fees'] && (selectedRoom.property_price['old_reservation_fees'] > selectedRoom.property_price['reservation_fees']), 'me-2 mediumGray subtitle_2 text-decoration-line-through':booking?.reduced_reservation_fees && (booking?.reduced_reservation_fees < booking?.reservation_fees) }"
          *ngIf="selectedRoom.property_price['reservation_fees'] != 0 && (!booking?.reduced_reservation_fees || (!selectedRoom.property_price?.old_reservation_fees && (!selectedRoom.property_price?.old_reservation_fees > !selectedRoom.property_price?.reservation_fees )))">
          {{ selectedRoom.property_price['reservation_fees'] | number: '1.0-0'}}€
        </span>
        <span class="text-grad-red" *ngIf="booking?.reduced_reservation_fees && (booking?.reduced_reservation_fees < booking?.reservation_fees)">
        {{ booking.reduced_reservation_fees  | number: '1.0-0' }}€
      </span>
      </small>
    </div>
  </div>

  <div *ngIf="!isAllSummaryOpen" class="d-flex justify-content-center pt-3 pb-3">
    <button type="button" (click)="openAllSummary()" class="btn btn-lf-secondary shadow-none border bg-transparent">
      {{ 'PROCESSES.ACCOMMODATION.LIST.PAYMENT_SUMMARY.DISPLAY_ALL' | translate }}
    </button>
  </div>

  <div *ngIf="isAllSummaryOpen">
    <div class="flex-column border-bottom border-1 pb-2 mb-2 col-fees">
      <span class="subtitle_1">{{ 'PROCESSES.ACCOMMODATION.LIST.PAYMENT_SUMMARY.SIGNATURE_PROCESS' | translate }}</span>
      <span class="text_1"> {{ 'PROCESSES.ACCOMMODATION.LIST.PAYMENT_SUMMARY.SIGNATURE_PROCESS_TO' | translate }}</span>

      <div class="d-flex justify-content-between mt-2 line-fees">
        <small class="text-underline subtitle_2 mediumGray"
          ngbTooltip="{{ 'PROCESSES.ACCOMMODATION.P_SPEC.LIST.PARTNER_FEES' | translate }}"
          placement="top-start">{{ 'PROCESSES.ACCOMMODATION.LIST.PAYMENT_SUMMARY.LANDLORD_FEES' | translate }}</small>
        <small class="title_3">
          <span class="text-decoration-line-through me-2 mediumGray subtitle_2" *ngIf="selectedRoom.property_price.oldPartnerFees">
          {{ selectedRoom.property_price['oldPartnerFees'] | number: '1.0-0'}}€
        </span>
          <span [ngClass]="{'text-grad-red':selectedRoom.property_price.oldPartnerFees }">
            {{ selectedRoom.partner_fees | number: '1.0-0'}}€
          </span>
        </small>
      </div>

      <div class="d-flex justify-content-between mt-2 line-fees">
        <small class="text-underline subtitle_2 mediumGray"
          ngbTooltip="{{ 'PROCESSES.ACCOMMODATION.P_SPEC.LIST.CAUTION_BACK' | translate }}"
          placement="top-start">{{ 'PROCESSES.ACCOMMODATION.LIST.PAYMENT_SUMMARY.DEPOSIT' | translate }}</small>
        <small class="title_3">
          <span *ngIf="selectedRoom.property_price['deposit'] != 0">
            {{ selectedRoom.property_price['deposit'] | number: '1.0-0'}}€
          </span>
        </small>
      </div>

      <div class="d-flex justify-content-between mt-2 line-fees">
        <small class="text-underline subtitle_2 mediumGray"
          ngbTooltip="{{ 'PROCESSES.ACCOMMODATION.P_SPEC.LIST.PRORATA_RENT' | translate }}"
          placement="top-start">{{ 'PROCESSES.ACCOMMODATION.LIST.PAYMENT_SUMMARY.FIRST_RENT' | translate }}</small>
        <small class="title_3">
          {{firstMonthRent | number: '1.0-0'}}€
        </small>
      </div>
    </div>

    <div class="flex-column border-bottom border-1 pb-2 mb-2">
      <span class="subtitle_1">{{ 'PROCESSES.ACCOMMODATION.LIST.PAYMENT_SUMMARY.MONTHLY_RENT_DATE' | translate }}</span>

      <div class="d-flex justify-content-between mt-2 line-fees">
        <div>
           <span class="text-underline subtitle_2 mediumGray"
             ngbTooltip="{{ 'PROCESSES.ACCOMMODATION.P_SPEC.LIST.RESERVATION_MIN' | translate }}"
             placement="top-start">
            {{ 'PROCESSES.ACCOMMODATION.LIST.PAYMENT_SUMMARY.MONTHLY_RENT' | translate }}
          </span>
          <span class="minitext_1"> {{ 'PROCESSES.ACCOMMODATION.LIST.PAYMENT_SUMMARY.MONTHLY_RENT_TO' | translate }}</span>
        </div>

        <span *ngIf="selectedRoom.property_price['price'] != 0" class="title_3">
          {{ selectedRoom.property_price['price'] | number: '1.0-0'}}€
        </span>
      </div>
    </div>
  </div>
</div>
